import { useCallback, useState } from "react";
export function useCopyToClipboard(resetInterval = 2000) {
  const [isCopied, setCopied] = useState(false);
  const copy = useCallback(async d => {
    var _navigator;
    if (!((_navigator = navigator) !== null && _navigator !== void 0 && _navigator.clipboard)) {
      console.warn("Clipboard not supported");
      return false;
    }
    try {
      const item = typeof d === "string" || typeof d === "number" ? new ClipboardItem({
        "text/plain": new Blob([`${d}`], {
          type: "text/plain"
        })
      }) : d;
      await navigator.clipboard.write([item]);
      setCopied(true);
      setTimeout(() => setCopied(false), resetInterval);
      return true;
    } catch (error) {
      console.warn("Copy failed", error);
      setCopied(false);
      return false;
    }
  }, [resetInterval]);
  return [isCopied, copy];
}
//# sourceMappingURL=useCopyToClipboard.js.map